export default "__VITE_ASSET__6d855c59__"